import { api } from './api';

export const analyticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getWarehouseAnalytics: builder.query({
      query: () => {
        return {
          url: 'getWarehouseAnalytics',
          method: 'POST',
          body: {
          },
        };
      },
    }),
    getTopCustomers: builder.query({
      query: (daysBack) => ({
        url: 'getTopCustomers',
        method: 'POST',
        body: { daysBack },
      }),
    }),
    getTrendingProducts: builder.query({
      query: ({ daysBack, excludeCollections }) => ({
        url: 'getTrendingProducts',
        method: 'POST',
        body: { daysBack, excludeCollections },
      }),
    }),
    getBestSellers: builder.query({
      query: (daysBack) => ({
        url: 'getBestSellers',
        method: 'POST',
        body: { daysBack },
      }),
    }),
  }),
});

export const {
  useGetWarehouseAnalyticsQuery,
  useGetTopCustomersQuery,
  useGetTrendingProductsQuery,
  useGetBestSellersQuery,
} = analyticsApi;

